import { render } from "./ProjectFeasibility.vue?vue&type=template&id=2ed91b05&scoped=true"
import script from "./ProjectFeasibility.vue?vue&type=script&lang=js"
export * from "./ProjectFeasibility.vue?vue&type=script&lang=js"

import "./ProjectFeasibility.vue?vue&type=style&index=0&id=2ed91b05&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed91b05"]])

export default __exports__